import { useEffect } from 'react';

/**
 * Keyboard shortcuts hook
 * Provides common keyboard shortcuts for improved navigation
 *
 * @param {Object} shortcuts - Callback functions for different shortcuts
 * @param {Function} shortcuts.onEscape - Called when Escape key is pressed
 * @param {Function} shortcuts.onEnter - Called when Enter key is pressed (not in textarea)
 * @param {Function} shortcuts.onCmdEnter - Called when Cmd/Ctrl+Enter is pressed
 * @param {Function} shortcuts.onCmdK - Called when Cmd/Ctrl+K is pressed
 */
export const useKeyboardShortcuts = (shortcuts) => {
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Escape - Close modals, cancel actions
      if (e.key === 'Escape') {
        shortcuts.onEscape?.();
      }

      // Enter (not in textarea) - Submit forms, confirm actions
      if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') {
        if (e.metaKey || e.ctrlKey) {
          // Cmd/Ctrl + Enter
          shortcuts.onCmdEnter?.();
        } else {
          shortcuts.onEnter?.();
        }
      }

      // Cmd/Ctrl + K - Open command palette, search
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        shortcuts.onCmdK?.();
      }

      // Cmd/Ctrl + / - Show keyboard shortcuts help
      if ((e.metaKey || e.ctrlKey) && e.key === '/') {
        e.preventDefault();
        shortcuts.onHelp?.();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [shortcuts]);
};

export default useKeyboardShortcuts;
